import * as React from "react";
import { SVGProps } from "react";

const Key = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16.75 9.157a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.75.657a8.25 8.25 0 0 0-7.851 10.79L.513 18.835A1.75 1.75 0 0 0 0 20.072v2.835c0 .967.784 1.75 1.75 1.75h1.5A1.75 1.75 0 0 0 5 22.907v-1a.25.25 0 0 1 .25-.25h2.735a.75.75 0 0 0 .545-.22l.214-.213A.875.875 0 0 0 9 20.606v-1.449a.25.25 0 0 1 .25-.25h1.086c.464 0 .91-.184 1.237-.512l1.636-1.636A8.25 8.25 0 1 0 15.75.658ZM9 8.907a6.75 6.75 0 1 1 4.288 6.287.75.75 0 0 0-.804.168l-1.971 1.972a.25.25 0 0 1-.177.073H9.25a1.75 1.75 0 0 0-1.75 1.75v1H5.25a1.75 1.75 0 0 0-1.75 1.75v1a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-2.835a.25.25 0 0 1 .073-.177l7.722-7.722a.75.75 0 0 0 .168-.804A6.73 6.73 0 0 1 9 8.907Z"
    />
  </svg>
);

export default Key;
